// src/pages/Register/EmailRegisterPage.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import LoadingIndicator from '../../components/LoadingIndicator';
import { registerEmail } from '../../services/authService';
import './EmailRegisterPage.css';

const EmailRegisterPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await registerEmail({ email });
      // 成功したら検証画面へ遷移
      navigate(`/register/verify?email=${encodeURIComponent(email)}`);
    } catch (err: any) {
      setMessage(
        err.response?.data?.detail ||
          '送信に失敗しました。既に登録済みの可能性があります。'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="email-register-page">
      <h1>新規登録</h1>
      {loading && <LoadingIndicator isFullPage={false} />}
      {message && <div className="notification error">{message}</div>}
      <form onSubmit={handleSubmit}>
        <label>メールアドレス</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="example@example.com"
        />
        <Button type="submit" disabled={loading}>
          {loading ? '送信中...' : '確認コードを送信'}
        </Button>
      </form>
    </div>
  );
};

export default EmailRegisterPage;
